export default "__VITE_ASSET__DeY4uSHZ__"